{{#each this}}
<li data-id="{{id}}" class="things-item">
    <img src="{{mainImg}}" alt="{{name}}" class="thing-img">
    <span class="thing-name">{{name}}</span>
    <span class="thing-price">{{price}} <span class="thin-current">uah</span></span>
</li>
{{/each}}